import { render, staticRenderFns } from "./select-identity.vue?vue&type=template&id=039cfb44&scoped=true&"
import script from "./select-identity.vue?vue&type=script&lang=js&"
export * from "./select-identity.vue?vue&type=script&lang=js&"
import style0 from "./select-identity.vue?vue&type=style&index=0&id=039cfb44&lang=scss&scoped=true&"
import style1 from "./select-identity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cfb44",
  null
  
)

export default component.exports